import { ScreenSize } from 'ha/modules/UI/constants';

export const STATE_NAME = 'cities';

export const ImageHeight = {
  [ScreenSize.XS]: 210,
  [ScreenSize.SM]: 210,
};
